import { all } from "redux-saga/effects";
import BlogListSagas from "./blog-list/saga";
import blogDetailsSaga from "./blog-details/saga";
import blogHeaderSaga from "./blog-header/saga";

export default function* rootSaga() {
  yield all([BlogListSagas(), blogDetailsSaga(), blogHeaderSaga()]);
}
